import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureaddCourses, successaddCourses } from "./AddCoursesSlice";
import { PayloadAction } from "@reduxjs/toolkit";

import {
  failuredeleteCourses,
  successdeleteCourses,
} from "./DeleteCoursesSlice";
import { failurelistCourses, successlistCourses } from "./ListCoursesSlice";
import { failureEditCourses, successEditCourses } from "./EditCoursesSlice";
import { ICourseslist } from "../../../Pages/Courses/ICourses";

// list
const ListCoursesApi = () => {
  return api.get("/api/package/courses");
};

export function* ListCoursesCall() {
  try {
    const response: AxiosResponse = yield call(ListCoursesApi);
    yield put(successlistCourses(response.data));
  } catch (error) {
    yield put(failurelistCourses(error));
  }
}

// add
// const AddCoursesApi = (action: PayloadAction<ICourseslist>) => {
//   console.log(action.payload);

//   const formData = new FormData();
//   action.payload.image_url &&
//     formData.append("image_url", action.payload.image_url);

//   return api.post("/api/package/courses/add", formData,
//      input: action.payload ,
//   );
// };

// export function* AddCoursesCall(action: PayloadAction<ICourseslist>) {
//   try {
//     const response: AxiosResponse = yield call(AddCoursesApi, action);
//     yield put(successaddCourses(response.data));
//   } catch (error) {
//     yield put(failureaddCourses(error));
//   }
// }

// API call to add a course
const AddCoursesApi = (action: PayloadAction<ICourseslist>) => {
  const formData = new FormData();

  // Add file
  if (action.payload.image_url instanceof File) {
    formData.append("image_url", action.payload.image_url);
  }

  // Append the entire payload as a JSON string under "input"
  const payloadWithoutFile = { ...action.payload };
  // delete payloadWithoutFile.image_url;

  formData.append("input", JSON.stringify(payloadWithoutFile));

  return api.post("/api/package/courses/add", formData);
};

// Saga to handle the API call
export function* AddCoursesCall(action: PayloadAction<ICourseslist>) {
  try {
    const response: AxiosResponse = yield call(AddCoursesApi, action);
    yield put(successaddCourses(response.data));
  } catch (error: any) {
    yield put(failureaddCourses(error.response?.data || error.message));
  }
}

// edit
const EditCoursesApi = (action: PayloadAction<ICourseslist>) => {
  const formData = new FormData();

  // Add file
  if (action.payload.image_url instanceof File) {
    formData.append("image_url", action.payload.image_url);
  }

  // Append the entire payload as a JSON string under "input"
  const payloadWithoutFile = { ...action.payload };
  // delete payloadWithoutFile.image_url;

  formData.append("input", JSON.stringify(payloadWithoutFile));

  return api.put("/api/package/course/update", formData, {
    params: { id: action.payload.id },
  });
};

export function* EditCoursesCall(action: PayloadAction<ICourseslist>) {
  try {
    const response: AxiosResponse = yield call(EditCoursesApi, action);
    yield put(successEditCourses(response.data));
  } catch (error) {
    yield put(failureEditCourses(error));
  }
}

// delete
const DeleteCoursesApi = (action: PayloadAction<number>) => {
  return api.delete("/api/package/course/delete", {
    params: { id: action.payload },
  });
};

export function* DeleteCoursesCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteCoursesApi, action);
    yield put(successdeleteCourses(response.data));
  } catch (error) {
    yield put(failuredeleteCourses(error));
  }
}
